import type { ComponentDescriptionTracking } from '@ardoq/component-description-editor';
import { trackEvent } from '../../tracking/tracking';
import {
  ScopeDataEventLocations,
  ScopeDataTrackingEvents,
} from '../tracking/types';

const buildTracking = (
  from: ScopeDataEventLocations
): ComponentDescriptionTracking => ({
  onGenerationAttempted: () =>
    trackEvent(ScopeDataTrackingEvents.GENERATE_COMPONENT_DESCRIPTION, {
      from,
    }),
  onGenerationSucceeded: () =>
    trackEvent(
      ScopeDataTrackingEvents.GENERATE_COMPONENT_DESCRIPTION_SUCCESSFUL,
      { from }
    ),
  onGenerationDeclinedByLlm: (reason: string) =>
    trackEvent(ScopeDataTrackingEvents.GENERATE_COMPONENT_DESCRIPTION_ERROR, {
      from,
      reason,
    }),
});

// Built once per location so the callbacks keep a stable identity: the shared
// generation hook memoises on them, and the editors that auto-generate capture
// the memoised function in a mount-only effect.
const trackingByLocation: Record<
  ScopeDataEventLocations,
  ComponentDescriptionTracking
> = {
  [ScopeDataEventLocations.COMPONENT_BUILDER]: buildTracking(
    ScopeDataEventLocations.COMPONENT_BUILDER
  ),
  [ScopeDataEventLocations.COMPONENT_OVERVIEW]: buildTracking(
    ScopeDataEventLocations.COMPONENT_OVERVIEW
  ),
  [ScopeDataEventLocations.INVENTORY]: buildTracking(
    ScopeDataEventLocations.INVENTORY
  ),
};

export const getComponentDescriptionTracking = (
  from: ScopeDataEventLocations
): ComponentDescriptionTracking => trackingByLocation[from];
